export const CARRIER_CONSTRAINTS = {
    name: { maxLength: 60, label: 'Carrier name' },
    trackingUrl: { maxLength: 512, label: 'Tracking link', placeholder: '{number}' },
    serviceName: { maxLength: 255, label: 'Service name' },
};
//# sourceMappingURL=constraints.js.map